export default __webpack_public_path__ + "media/images/portfolio/gallery-09-1200x753_original-931f680565a9c2cb194f97cd80769f4e.jpg";